import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function RequireAuth({
  role,
  children,
}: {
  role?: 'global_superadmin';
  children: ReactNode;
}) {
  const { user, accessToken, hydrating, hydrate } = useAuth();
  const loc = useLocation();

  useEffect(() => {
    if (!user && !accessToken && hydrating === false) return;
    if (hydrating) hydrate();
  }, [user, accessToken, hydrating, hydrate]);

  if (hydrating) {
    return <div className="min-h-screen bg-dgal-ink text-dgal-mist flex items-center justify-center">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (role && user.role !== role) return <Navigate to="/app" replace />;
  return <>{children}</>;
}
